import React from 'react'
import {Link, useNavigate} from 'react-router-dom'
import {EvaArrowIosBackFill} from './icons/BackButton'
import CampaignAddSuccessfulImage from './icons/CampaignAddSuccessfulImage'

export default function CampaignAddSuccessful() {
  let navigate = useNavigate()
  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          cursor: 'pointer',
          alignContent: 'center',
          alignItems: 'center',
          justifyContent: 'flex-start',
        }}
        onClick={() => navigate(-1)}
      >
        <div style={{padding: 5, backgroundColor: 'white', borderRadius: 100, marginRight: 5}}>
          <EvaArrowIosBackFill />
        </div>
        <p style={{fontSize: 14, fontWeight: 'bold', margin: 0}}>Back</p>
      </div>
      <div
        style={{
          margin: 30,
          backgroundColor: 'white',
          paddingRight: 30,
          paddingLeft: 30,
          paddingTop: 40,
          paddingBottom: 60,
          borderRadius: 10,
        }}
      >
      <p style={{fontSize:24, color:'#736F6F', textAlign:'center'}}>You have successfully scheduled a campaign </p>
      <div style={{justifyContent:'center', justifyItems:'center', display:'flex'}}>
      <CampaignAddSuccessfulImage/>

      </div>

      <div className='d-flex justify-content-end mt-3'>
              <Link
                to='/campaign-dashboard'
                type='submit'
                className='btn'
                style={{
                  padding: '10px 70px',
                  borderRadius: 20,
                  backgroundColor: '#202020',
                  color: '#DBDEE0',
                  // marginTop: 20,
                }}
                // onClick={handleFormSubmit}
              >
                Close
              </Link>
            </div>
      </div>
    </>
  )
}
